import { UISection, UIGroup, UIMemo, UIMemoContent, UIShareStatus, UIUserGroup, StateCode } from '../model/UiShapes';
import { DEFAULT_SECTION_GUID, DEFAULT_GROUP_GUID } from './MetaSetting';

export const DataStatus = {
  UNKNOWN: 0,
  UPDATED: 1,
  UPDATING: 2,
  NOTUPDATE: 3
};

export const defaultSection: UISection = {
  userId: '',
  guid: DEFAULT_SECTION_GUID,
  createTimestamp: 0,
  stateCode: StateCode.NORMAL,
  modifyTimestamp: 0,
  name: '',
  sectionType: 0,
  hasShare: false,
  shareTypes: [],
  updateStatus: DataStatus.NOTUPDATE
};

export const defaultGroup: UIGroup = {
  userId: '',
  guid: DEFAULT_GROUP_GUID,
  createTimestamp: 0,
  stateCode: StateCode.NORMAL,
  description: '',
  modifyTimestamp: 0,
  name: '',
  sectionId: '-',
  hasShare: false,
  shareTypes: [],
  updateStatus: DataStatus.NOTUPDATE
};

export const emptySection: UISection = {
  userId: '',
  guid: '',
  createTimestamp: 0,
  stateCode: StateCode.NORMAL,
  modifyTimestamp: 0,
  name: '',
  sectionType: 0,
  hasShare: false,
  shareTypes: [],
  updateStatus: DataStatus.NOTUPDATE
};

export function getEmptySection(): UISection {
  return Object.assign({}, emptySection);
}

export const emptyGroup: UIGroup = {
  userId: '',
  guid: '',
  createTimestamp: 0,
  stateCode: StateCode.NORMAL,
  description: '',
  modifyTimestamp: 0,
  name: '',
  sectionId: '-',
  hasShare: false,
  shareTypes: [],
  updateStatus: DataStatus.NOTUPDATE
};

export function getEmptyGroup(): UIGroup {
  return Object.assign({}, emptyGroup);
}

export const emptyMemo: UIMemo = {
  userId: '',
  guid: '',
  title: '',
  createTimestamp: 0,
  modifyTimestamp: 0,
  stateCode: StateCode.NORMAL,
  groupId: '',
  syncStateCode: 0,
  hasShare: false,
  shareTypes: [],
  contentMark: 0,
  updateStatus: DataStatus.NOTUPDATE
};

export function getEmptyMemo(): UIMemo {
  return Object.assign({}, emptyMemo);
}

export const emptyContentMemo: UIMemoContent = {
  memoId: '',
  content: ''
};

export function getEmptyMemoContent(): UIMemoContent {
  return Object.assign({}, emptyContentMemo);
}

export const emptyShareSetting: UIShareStatus = {
  guid: '',
  createTimestamp: 0,
  modifyTimestamp: 0,
  shareInfo: []
};

export function getEmptyShare(): UIShareStatus {
  return Object.assign({}, emptyShareSetting);
}

export const SHARE_SETTING_TYPE_MARK = {
  PUBLIC: 1,
  USER_GROUP: 2,
  USER: 3
};

export const SHARE_TYPE_MARK = {
  SECTION: 1,
  GROUP: 2,
  MEMO: 3
};

export const MEMO_PAGE_LIST_PANEL = {
  SECTION: 1,
  GROUP: 2,
  MEMO: 3,
  SHARE: 4
};

export const MEMO_PAGE_VIEW_PANEL = {
  LIST: 0,
  EDIT: 1,
  SHARE: 2
};

export const defaultUserGroup: UIUserGroup = {
  userId: '',
  guid: DEFAULT_GROUP_GUID,
  createTimestamp: 0,
  stateCode: StateCode.NORMAL,
  modifyTimestamp: 0,
  name: '',
  userMarks: []
};

export const emptyUserGroup: UIUserGroup = {
  userId: '',
  guid: '',
  createTimestamp: 0,
  stateCode: StateCode.NORMAL,
  modifyTimestamp: 0,
  name: '',
  userMarks: []
};

export function getEmptyUserGroup(): UIUserGroup {
  return Object.assign({}, emptyUserGroup);
}

export const VIEW_MEMO_STATUS_MARK = {
  SUCCESS: 0,
  TARGET_NOT_FOUND: 1,
  NOT_AUTH: 2
};

export const SyncResult = {
  SOURCE_UPDATED: -1,
  TARGET_UPDATED: 1,
  NO_UPDATE: 0,
  OTHER: 2
};

export const UpdateTarget = {
  SUCCESS: 0,
  SECTION: 1,
  GROUP: 2,
  MEMO: 3,
  MEMO_TAG: 4,
  MEMO_TRAINING: 5
};

export const UpdateType = {
  UNKNOWN: 0,
  CREATE: 1,
  UPDATE: 2,
  DELETE: 3
};

export const ESMessageType = {
  UNKNOWN: 0,
  MEMO_UPDATE: 1,
  COMMAND_RESULT: 2,
  TRAINING_RESULT: 3,
  ANALYSIS_UPDATE: 4 // 新增：分析更新消息类型
};

// 数据类型枚举
export const DataType = {
  TEXT: 'TEXT', // 文本
  IMAGE: 'IMAGE', // 图像
  OBJECT: 'OBJECT', // 对象
  TAG: 'TAG', // 标签
  RELATION: 'RELATION', // 关系
  MEMO: 'MEMO', // 备忘录
  INDEX: 'INDEX' // 索引
};

// 分析更新消息内容接口
export interface AnalysisUpdateMessage {
  authorId: string;
  parentId: string;
  targetId: string;
  content: string;
  updateType: string;
  dataType: string;
}

export interface AnalysisUpdateWSMessage {
  messageType: number;
  messageContent: AnalysisUpdateMessage;
}
